import { useState } from "react";
export const useAdvertisementDetailState = () => {
  const [advertisement, setAdvertisement] = useState(null);
  const [sponsor, setSponsor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  return {
    advertisement,
    setAdvertisement,
    sponsor,
    setSponsor,
    loading,
    setLoading,
    error,
    setError,
  };
};
